<template>
  <div class="dashboard">
    <img alt="Vue logo" src="@/assets/bg.jpg" width="500px">
    <footer-controlla></footer-controlla>
  </div>
</template>

<script>
import FooterControlla from '@/components/FooterControlla.vue'

export default {
  name: 'dashboard',
  components: {
    FooterControlla
  }
}
</script>

<style scoped>
.dashboard {
  background-color: #fafafa;
  padding-top: 110px;
  text-align: center;
  height: 100vh;
}
img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>
